import { Spacing } from "@bonusx-global/bx-design-system";
import type { Variant } from "@mui/material/styles/createTypography";
import useIsMobile from "../../../../hooks/device/useIsMobile";
import SectionTitle from "../../SectionTitle";

interface AiChatbotSuggestedPromptPageHeaderProps {
  title: string;
  titleVariant?: Variant;
}

function AiChatbotSuggestedPromptPageHeader({
  title,
  titleVariant = "h6",
}: Readonly<AiChatbotSuggestedPromptPageHeaderProps>): JSX.Element {
  const isMobile = useIsMobile();

  return <SectionTitle variant={titleVariant} title={title} isMobile={isMobile} paddingBottom={Spacing["750"]} />;
}

export default AiChatbotSuggestedPromptPageHeader;
